import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { getCategories } from "./../../services/productsService.js";
import { dataActions } from "../../store/index.js";
import Loader from "./core-components/Loader.tsx";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
  padding: 1rem;

  @media (min-width: 500px) {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
`;

const Item = styled(Link)`
  white-space: nowrap;
  text-decoration: none;
  color: var(--tertiary-font-color);
  &:hover {
    text-decoration: underline;
    cursor: pointer;
    color: var(--secondary-font-color);
  }
`;

interface Props {
  closeDropdown?: () => void;
}
const CategoriesComponent: React.FC<Props> = ({ closeDropdown }) => {
  const dispatch = useDispatch();
  const { data: categories, isLoading } = useQuery({
    queryKey: ["category"],
    queryFn: () => getCategories(),
    retry: false,
    staleTime: 30 * 60 * 1000,
  });

  useEffect(() => {
    if (categories && categories.length > 0) {
      dispatch(dataActions.addCategories(categories));
    }
  }, [categories, dispatch]);

  const getURL = (category: string) => {
    if (!category) return "";
    return category.toLowerCase().replace(/\s+/g, "-");
  };
  if (isLoading) return  <Loader />;
  return (
    <Wrapper data-testid="mobile-header-categories">
      {categories
        ? categories.map((category:any, index: number) => (
            <Item
              key={category.categoryID}
              to={`/shop/${getURL(category.categoryName)}`}
              onClick={() => {
                closeDropdown && closeDropdown();
              }}
            >
              {category.categoryName}
            </Item>
          ))
        : null}
    </Wrapper>
  );
};

export default CategoriesComponent;
